/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React from 'react'
import { withRouter } from "react-router-dom";
import { useState, useEffect, useRef } from 'react';
import Button from 'Admin/elements/CustomButton/CustomButton.jsx';
import {
  Modal
} from 'react-bootstrap';
import * as API from 'Front/api/emr';
import { ACTIONS } from './Prescription';
import {
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";
import NotificationSystem from 'react-notification-system';
import { style } from "Admin/variables/Variables.jsx";


const AddRecommendationOnPrescription = ({ setModalStatusRecommendationOfPrescription, patientId, appointmentId, modalStatusRecommendationOfPrescription, dispatch, selectedRecommendation }) => {
  const [recommendationList, setRecommendationList] = useState([])
  const [arrRecommendation, setArrRecommendation] = useState([])
  const [onPageLoad, setOnPageLoad] = useState(false)
  const [isRecommendationExist, setIsRecommendationExist] = useState(false)
  const [formData, setFormData] = useState({
    recommendedType: "top",
    recommendedPrescription: ""
  });
  const [maxLength, setMaxLength] = useState(false)
  const [errors, setErrors] = useState({});
  const notificationSystem = useRef(null)
  const [isCustomRecommendation, setIsCustomRecommendation] = useState(false)
  const [isDisabledAddToClinicButton, setIsDisabledAddToClinicButton] = useState(true)

  const showRecommendationFun = () => {
    setModalStatusRecommendationOfPrescription(true);
    getRecommendedPrescription()
  }

  const getRecommendedPrescription = async () => {
    let resp = await API.recommendedPrescription({ patientId: patientId, appointmentId: appointmentId, clinicId: localStorage.getItem("clinicId") });
    if (resp.data.status === "Success" && resp.data.statusCode === 200) {
      setRecommendationList(resp.data.recommendedPrescriptionData.data)
      setArrRecommendation(resp.data.recommendedPrescription)
      setOnPageLoad(true)
    }

  }

  const findRecommendation = () => {
    recommendationList.map(recommendation => {
      arrRecommendation.map(item => {
        if (item.recommendedPrescriptionId === recommendation._id) {
          checkRecommendation(item.recommendedPrescriptionId)
        }
        setArrRecommendation([...arrRecommendation])
      })

    })
  }

  const checkRecommendation = (recommendedPrescriptionId) => {
    let chkRecommendations = document.getElementsByName("recommendation");
    for (var itm of chkRecommendations) {
      if (recommendedPrescriptionId === itm.getAttribute("id")) {
        itm.checked = true;
      }
    }
  }

  const addOrDeleteRecommendation = (e, row) => {
    if (e.target.checked) {
      let arr = [];
      arr.push({
        "recommendedPrescriptionId": row._id,
        "recommendedPrescription": row.recommendedPrescription,
        "recommendedType": row.recommendedType
      })

      setArrRecommendation([...arr, ...arrRecommendation])

    } else {
      deleteRecommendation(e)
    }

  }

  const deleteRecommendation = (e) => {
    let arr = arrRecommendation;
    arr.map((itm, idx) => {
      if (itm.recommendedPrescriptionId === e.target.id) {
        arr.splice(idx, 1);
        return;
      }
    })
    setArrRecommendation([...arr])
  }

  const submitHandler = async (e) => {
    e.preventDefault();
    let resp = await API.addRecommendation({ recommendedData: [{ patientId: patientId, appointmentId: appointmentId, recommendedPrescription: arrRecommendation }] });
    if (resp.data.status === "Success" && resp.data.statusCode === 200) {
      dispatch({ type: ACTIONS.ADD_RECOMMENDATION, payload: { "recommendation": arrRecommendation } })
    }
    hideModal()
  }

  const hideModal = () => {
    setModalStatusRecommendationOfPrescription(false)
    setErrors({})
    setIsRecommendationExist(false)
    setFormData({ recommendedPrescription: "", recommendedType: "top" })
  }

  useEffect(() => {
    if (onPageLoad)
      findRecommendation()
    setOnPageLoad(false)
  }, [onPageLoad])

  const inputHandler = (e) => {
    if (isRecommendationExist)
      setIsRecommendationExist(false)
    let saveFormData = formData;
    if (e.target.name === "recommendedPrescription") {
      if (e.target.value.length >= 300) {
        setMaxLength(true)
        setIsDisabledAddToClinicButton(true)
        return
      } else {
        setMaxLength(false)
        let str = e.target.value.replace(/\s+/g, " ").substring(0, 300);
        saveFormData[e.target.name] = str.trimStart()

      }
    }
    if (e.target.name === "recommendedType") {
      saveFormData[e.target.name] = e.target.value
    }
    setFormData({ ...formData, ...saveFormData });
    validate();
  }

  const validate = () => {

    let post = formData;
    let errArr = errors;
    let errflag = true;
    if (post.recommendedPrescription && post.recommendedPrescription != '') {
      errArr.recommendedPrescription = '';
      setIsDisabledAddToClinicButton(false)
    } else {
      errArr.recommendedPrescription = 'error';
      errflag = false;
      setIsDisabledAddToClinicButton(true)
    }
    setErrors({ ...errArr });
    return errflag;

  }

  const addCustomRecommendation = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        let resp = await API.addCustomRecommendation({ ...formData, clinicId: localStorage.getItem("clinicId") });
        console.log(resp, "------resp")
        if (resp.data.status === "Success" && resp.data.statusCode === 200) {
          if (resp?.data?.flag)
            setIsRecommendationExist(true)
          else {
            const notification = notificationSystem.current;
            let msg = "Recommendation Save Successfully"
            notification.addNotification({
              title: (<span data-notify="icon" className="pe-7s-check" style={{ fontSize: '30px', color: '#fff', padding: '0px !important', top: '0% !important' }}></span>),
              message: <div>
                {msg}
              </div>,
              level: 'success',
              position: 'tr',
              autoDismiss: 2,
            });
            let cloneRecommendationList = recommendationList
            recommendationList.push(resp.data.data)
            setRecommendationList([...cloneRecommendationList])
            let cloneArrayRecommendation = arrRecommendation
            let newCustomRecommendation = {
              "recommendedPrescriptionId": resp.data.data._id,
              "recommendedPrescription": resp.data.data.recommendedPrescription,
              "recommendedType": resp.data.data.recommendedType
            }
            cloneArrayRecommendation.push(newCustomRecommendation)
            setArrRecommendation([...cloneArrayRecommendation])
            setIsCustomRecommendation(true)
            setErrors({})
          }
        }
      } catch (err) {
        console.log(err.message, "---------error")
      }
    }
  }

  useEffect(() => {
    if (isCustomRecommendation) {
      findRecommendation()
      setIsCustomRecommendation(false)
      setFormData({ recommendedPrescription: "", recommendedType: "top" })
    }
  }, [isCustomRecommendation])

  return (
    <span >
      <Button type="button" id="btnShowRecommendation" onClick={e => showRecommendationFun()} className="btn btn-fill btn-primary">Recommendation On Prescription</Button>
      <Modal show={modalStatusRecommendationOfPrescription} onHide={hideModal} dialogClassName="modal-xl">
        <Modal.Header closeButton className="bg-thumbcolor">
          <div>
            <NotificationSystem ref={notificationSystem} style={style} />
          </div>
          <Modal.Title id="example-modal-sizes-title-lg">Recommendation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="suggetion-box-enlarge">

          <div className="suggestion-lists">
            <div className="selected-complaints">
              <h5>Recommendation Selected</h5>
            </div>
            <div className="suggestion-list">
              {
                recommendationList.map((itm, idx) => {
                  return (<div class="form-check form-check-emr">
                    <input class="form-check-input" id={itm._id} type="checkbox" value={itm.recommendedPrescription} onChange={(e) => { addOrDeleteRecommendation(e, itm) }} name="recommendation" />
                    <label class="form-check-label" for={itm._id}>
                      {itm.recommendedPrescription.substring(0, 100)}
                    </label>
                  </div>)

                })
              }

            </div>
            <div className='row'>
              <div className='col-sm-6' style={{ marginTop: '15px' }}>
                <form >
                  {isRecommendationExist &&
                    <div style={{ 'color': 'red' }}><p>This recommendation already exist.</p></div>
                  }
                  <FormGroup>
                    <Col sm={5} className="spcc">
                      <select
                        className="form-control"
                        name="recommendedType"
                        value={formData.recommendedType}
                        onChange={(e) => {
                          inputHandler(e);
                        }}
                      >
                        <option value="top">Top Of Prescription</option>
                        <option value="bottom">Bottom Of Prescription</option>
                      </select>
                    </Col>
                    <Col sm={7} >
                      {maxLength &&
                        <span style={{ 'color': 'red' }}><p>Maximum 300 Characters are allowed.</p></span>
                      }
                      <FormControl rows="3" style={{ marginBottom: "10px" }} maxLength="300" componentClass="textarea" id="txtInstruction" name="recommendedPrescription" bsClass="form-control unmandt-f" value={formData?.recommendedPrescription ? formData?.recommendedPrescription : ''} placeholder="Instruction" onChange={e => { inputHandler(e); }} className={'' + (errors.recommendedPrescription ? errors.recommendedPrescription : '')} />
                    </Col>
                    <Col componentClass={ControlLabel} sm={12} >
                      <Button onClick={e => addCustomRecommendation(e)} className="btn btn-fill btn-primary" disabled={isDisabledAddToClinicButton}> Add To Clinic</Button>
                    </Col>
                  </FormGroup>

                </form>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-6' style={{ marginTop: '15px' }}>

              </div>
              <hr></hr>
            </div>
            <div className='text-right'>
              <Button onClick={e => submitHandler(e)} className="btn btn-primary btn-fill right">Save</Button>
            </div>
          </div>

        </Modal.Body>
      </Modal>
    </span>
  )
}

export default AddRecommendationOnPrescription